import {
    collection,
    deleteDoc,
    deleteField,
    doc,
    documentId,
    getDoc,
    getDocs,
    increment,
    limit,
    orderBy,
    query,
    startAfter,
    updateDoc,
    where,
    writeBatch
} from 'firebase/firestore';
import {deleteObject, getStorage, ref} from 'firebase/storage';
import {getDb, levelNames as levelNamesConstant, miniGames} from 'util/Constants';
import React, {useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Spinner
} from "reactstrap";
import step1 from "../../assets/img/icons/user/step-counting/step-1.png";
import step2 from "../../assets/img/icons/user/step-counting/step-2.png";
import step3 from "../../assets/img/icons/user/step-counting/step-3.png";
import step4 from "../../assets/img/icons/user/step-counting/step-4.png";
import step5 from "../../assets/img/icons/user/step-counting/step-5.png";
import step6 from "../../assets/img/icons/user/step-counting/step-6.png";
import step7 from "../../assets/img/icons/user/step-counting/step-7.png";
import step8 from "../../assets/img/icons/user/step-counting/step-8.png";
import Swal from "sweetalert2";
import {Link} from 'react-router-dom/cjs/react-router-dom.min';
import moment from "moment";

const Dashboard = ({signedInUser, togglePlanModal, metadata}) => {
    const [loading, setLoading] = useState(true);
    const [modal, setModal] = useState(false);
    const [events, setEvents] = useState([]);
    const [event, setEvent] = useState({});
    const [user, setUser] = useState({});

    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const value = queryParams.get('id');
    const isProgress = signedInUser.projectType === "progress";

    useEffect(() => {
        console.log(metadata);
        getUser().then(_user => {
            setUser(_user);
            getEvents(_user.id).then(_data => {
                setEvents(_data);
                setLoading(false);
            })
        })
    }, []);

    const getUser = async () => {
        let userId;
        if (value) {
            userId = value;
        } else {
            userId = signedInUser.uid
        }
        const docRef = doc(getDb(), "admins", userId);
        const docSnap = await getDoc(docRef);
        return {...docSnap.data(), id: userId};
    }
    const getEvents = async (userId) => {
        let eventRef = "";
        eventRef = query(collection(getDb(), "Events"), where("userId", "==", userId));
        const querySnapshot = await getDocs(eventRef);
        let arr = [];

        querySnapshot.forEach((doc) => {
            arr.push({id: doc.id, ...doc.data()})
        });
        return arr;
    }
    const toggle = (eventId) => {
        if (eventId) {
            const eventData = events.find((e) => e.eventId === eventId);
            console.log(eventData, "eventData");
            setEvent(eventData);
        } else {
            setEvent({})
        }
        setModal(!modal)
    };
    const push = (id, userId) => {
        if (signedInUser.role === "superAdmin") {
            history.push('/admin/leaderboard/' + id + "?superAdmin=gvb1hjj23n");
        } else {
            history.push('/admin/leaderboard/' + id)
        }
        localStorage.setItem("eventId", id)
    }
    const checkAssessments = () => {
        if (user?.assessmentsCount < user?.maxAssessments) {
            history.push('/assessment/index');
        } else {
            Swal.fire({
                title: `Maximum number of ${signedInUser.projectType === 'progress' ? 'games' : 'assessments'} reached`,
                text: `Please upgrade your account to increase your ${signedInUser.projectType === 'progress' ? 'games' : 'assessment'} limit`,
                icon: 'warning',
            }).then(r => {

            })
        }
    }
    const refreshUser = async () => {
        const user = await getUser();
        setUser(user);
    }
    const deleteEvent = async (eventId) => {
        if (!eventId) return;
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This action will permanently delete the event and related data!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        // If user cancels, stop the deletion process
        if (!result.isConfirmed) return;

        // Show non-blocking loading modal (do not await)
        Swal.fire({
            title: "Deleting...",
            text: "Please wait while we delete the event and its related data.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        try {
            // Get event data to check for old asset naming pattern (backward compatibility)
            const eventDoc = await getDoc(doc(getDb(), "Events", eventId));
            const eventData = eventDoc.exists() ? eventDoc.data() : null;

            // Delete storage assets (logo and video)
            const storage = getStorage();

            // Delete assets using new eventId-based naming pattern
            const logoRef = ref(storage, `eventAssets/${eventId}-logo`);
            const videoRef = ref(storage, `eventAssets/${eventId}-intro-video`);

            // Delete logo asset (ignore errors if file doesn't exist)
            await deleteObject(logoRef).catch((error) => {
                console.log("Logo asset (new pattern) not found or already deleted:", error);
            });

            // Delete video asset (ignore errors if file doesn't exist)
            await deleteObject(videoRef).catch((error) => {
                console.log("Video asset (new pattern) not found or already deleted:", error);
            });

            // Delete questions file from events folder (bucket -> events -> [eventId]_questions)
            const questionsRef = ref(storage, `events/${eventId}_questions`);
            await deleteObject(questionsRef).catch((error) => {
                console.log("Questions file not found or already deleted:", error);
            });

            // // Also try deleting assets with old naming pattern for backward compatibility
            if (eventData?.assessmentName && eventData?.assessmentFor) {
                const oldLogoRef = ref(storage, `${eventData.assessmentName}-${eventData.assessmentFor}-logo`);
                const oldVideoRef = ref(storage, `${eventData.assessmentName}-${eventData.assessmentFor}-Intro-Video`);

                await deleteObject(oldLogoRef).catch((error) => {
                    console.log("Logo asset (old pattern) not found or already deleted:", error);
                });

                await deleteObject(oldVideoRef).catch((error) => {
                    console.log("Video asset (old pattern) not found or already deleted:", error);
                });
            }

            console.log("Storage assets deleted for event:", eventId);

            // Delete all subcollections inside Events/{eventId} only (e.g. Events/apple_futuredrive/1, /2, /3, ...).
            // Subcollections exist only under Events; Levels collection has no subcollections. Do not use Levels here.
            // Firestore client cannot list subcollections, so we try every possible name from Constants + event doc selectedLevels.
            const deleteEventSubcollections = async (eventId, eventData) => {
                const eventDocRef = doc(getDb(), "Events", eventId);
                const subcollectionNames = new Set();

                // 1. All known level/subcollection names from app constants (covers "1","2",...,"10","Mini 1",...)
                if (levelNamesConstant?.length) levelNamesConstant.forEach(name => subcollectionNames.add(name));
                if (miniGames?.length) miniGames.forEach(m => {
                    if (m?.value) subcollectionNames.add(m.value);
                });

                // 2. From event document selectedLevels only
                if (eventData?.selectedLevels) {
                    ["competencies", "games", "cognitive", "aptitude"].forEach(key => {
                        const arr = eventData.selectedLevels[key];
                        if (Array.isArray(arr)) arr.forEach(level => {
                            if (level?.name) subcollectionNames.add(level.name);
                        });
                    });
                }

                // Delete all documents in each subcollection (no-op if subcollection doesn't exist)
                const BATCH_SIZE = 500; // Firestore batch limit
                for (const subcolName of subcollectionNames) {
                    try {
                        const subcollectionRef = collection(eventDocRef, subcolName);
                        // Quick check: skip if subcollection is empty (avoids full loop for 7,8,9,10,Mini 1-12, etc.)
                        const peekQuery = query(subcollectionRef, limit(1));
                        const peekSnap = await getDocs(peekQuery);
                        if (peekSnap.size === 0) continue;

                        // Subcollection has documents – run full paginated delete
                        let subcollectionQuery = query(
                            subcollectionRef,
                            orderBy(documentId()),
                            limit(BATCH_SIZE)
                        );
                        let snapshot = await getDocs(subcollectionQuery);
                        let totalDeleted = 0;

                        while (snapshot.size > 0) {
                            const batch = writeBatch(getDb());
                            snapshot.docs.forEach(doc => {
                                batch.delete(doc.ref);
                            });
                            await batch.commit();
                            totalDeleted += snapshot.size;

                            if (snapshot.size < BATCH_SIZE) break;

                            const lastDoc = snapshot.docs[snapshot.docs.length - 1];
                            subcollectionQuery = query(
                                subcollectionRef,
                                orderBy(documentId()),
                                startAfter(lastDoc.id),
                                limit(BATCH_SIZE)
                            );
                            snapshot = await getDocs(subcollectionQuery);
                        }
                        console.log(`Deleted ${totalDeleted} documents from subcollection '${subcolName}' for event:`, eventId);
                    } catch (error) {
                        console.error(`Error deleting subcollection '${subcolName}':`, error);
                    }
                }
            };

            // Delete all subcollections before deleting the parent document
            await deleteEventSubcollections(eventId, eventData);
            console.log("All subcollections deleted for event:", eventId);

            // Delete event document (now that all subcollections are deleted)
            await deleteDoc(doc(getDb(), "Events", eventId));
            console.log("Event deleted:", eventId);

            // Delete related documents in Users (batched, paginated)
            const deleteUsersByEventBatched = async (eventId) => {
                const BATCH_SIZE = 500; // Firestore limit per batch
                const usersCol = collection(getDb(), 'users');
                // Order by document id so we can paginate reliably
                let usersQuery = query(usersCol, where('eventId', '==', eventId), orderBy(documentId()), limit(BATCH_SIZE));
                let snapshot = await getDocs(usersQuery);
                let totalDeleted = 0;

                while (snapshot.size > 0) {
                    const batch = writeBatch(getDb());
                    snapshot.docs.forEach(d => batch.delete(d.ref));
                    await batch.commit();
                    totalDeleted += snapshot.size;

                    // If fewer than batch size, we're done
                    if (snapshot.size < BATCH_SIZE) break;

                    // Prepare next page
                    const lastDoc = snapshot.docs[snapshot.docs.length - 1];
                    usersQuery = query(usersCol, where('eventId', '==', eventId), orderBy(documentId()), startAfter(lastDoc.id), limit(BATCH_SIZE));
                    snapshot = await getDocs(usersQuery);
                }
                return totalDeleted;
            }

            const deletedUsersCount = await deleteUsersByEventBatched(eventId);
            console.log(`Deleted ${deletedUsersCount} user documents for event:`, eventId);

            // Decrement usersCount in admin document
            if (eventData?.userId) {
                const adminRef = doc(getDb(), "admins", eventData.userId);
                await updateDoc(adminRef, {
                    assessmentsCount: increment(-1),
                    ...(deletedUsersCount > 0 && {usersCount: increment(-deletedUsersCount)}),
                });
                console.log(`Decremented usersCount by ${deletedUsersCount} for admin:`, eventData.userId);
            }

            // Delete related document in Miscellaneous (document id = eventId)
            const miscRef = doc(getDb(), "miscellaneous", eventId);
            await deleteDoc(miscRef);

            console.log("Related miscellaneous deleted for event:", eventId);

            // Remove this event's key from analytics document in users collection
            const analyticsRef = doc(getDb(), "users", "analytics");
            await updateDoc(analyticsRef, {[eventId]: deleteField()}).catch((error) => {
                console.log("Analytics key for event not found or already removed:", error);
            });
            console.log("Removed event key from users/analytics for event:", eventId);

            // Delete related documents in Levels
            const levelsQuery = query(collection(getDb(), "Levels"), where("eventId", "==", eventId));
            const levelsSnapshot = await getDocs(levelsQuery);
            for (const levelDoc of levelsSnapshot.docs) {
                await deleteDoc(doc(getDb(), "Levels", levelDoc.id));
            }
            console.log("Related levels deleted for event:", eventId);

            // Remove from UI - match either id or eventId
            setEvents((prevEvents) => prevEvents.filter((ev) => ev.id !== eventId && ev.eventId !== eventId));
            refreshUser();
            await Swal.fire({
                title: "Deleted!",
                text: "Event and related data have been successfully deleted.",
                icon: "success",
                confirmButtonText: "OK",
            });

        } catch (error) {
            console.error("Error deleting event and related documents:", error);
            await Swal.fire({
                title: "Error!",
                text: "There was an issue deleting the event. Please try again.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    }
    const formatDate = (rawDate) => {
        if (rawDate && rawDate.seconds) {
            return moment.unix(rawDate.seconds).format("DD-MMM-YYYY hh:mm A"); // You can change the format if needed
        } else {
            console.error("Invalid Timestamp format");
            return "Invalid Date";
        }
    };

    return (<div>
        <Container className="mt-5">
            {signedInUser.role === "superAdmin" &&
                <Button className="createAssessment text-white" color="" onClick={() => history.goBack()}>
                    Back</Button>}
            <div className="d-flex justify-content-center flex-column align-items-center">
                <div className="mb-lg-5 w-75 d-flex justify-content-between align-items-end">
                    {signedInUser.role === "admin" && <div>
                        <Button className="createAssessment text-white" color=""
                                onClick={(e) => checkAssessments()}>
                            + Create New {metadata.environment !== "progress" && "Assessment"} Game
                        </Button>
                    </div>}
                    {!isProgress && <div className="text-center">
                        <label>Your plan is <span
                            className="text-capitalize font-weight-600 active-text">{signedInUser.plan}</span>
                            {signedInUser.expiry && signedInUser.expiry <= Date.now() &&
                                <span className="text-danger fs-14"> (Expired)</span>}
                        </label>
                        <div>
                            <Button color="" className="plan-button" onClick={togglePlanModal}> Upgrade your
                                plan</Button>
                        </div>
                    </div>}
                </div>
                <Card className="step1-card br-15">
                    <CardBody className="pt-3">
                        <Row className="px-4 pt-3">
                            <Col sm={12} lg={4} md={4}>
                                <div className="dashboard-info">
                                    Total Number of Users: {user.usersCount}
                                </div>
                            </Col>
                            <Col sm={12} lg={4} md={4}></Col>
                            <Col sm={12} lg={4} md={4}>
                                <div className="dashboard-info"> Total Number of Games
                                    : {user.assessmentsCount}</div>
                            </Col>
                        </Row>
                        <Container className="assessment-listing mt-3">
                            {loading ? (<div className="text-center mt-7">
                                <Spinner
                                    color={'primary'}
                                    size={''}
                                >
                                    Loading...
                                </Spinner>
                            </div>) : <>
                                {events.map((item, index) => {
                                        let formattedStart;
                                        let formattedEnd;
                                        if (item.startTime) {
                                            formattedStart = formatDate(item.startTime);
                                            formattedEnd = formatDate(item.endTime);
                                        }
                                        return (
                                            <div className="assessment-entity" key={index}>
                                                <div>{item.difficulty}</div>
                                                <Row className='d-flex justify-content-between mb-2'>
                                                    <Col>
                                                        <h1 className="text-white">{item.assessmentName}</h1>
                                                    </Col>
                                                    <Col className="text-right">
                                                    <span onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggle(item.eventId)
                                                    }} style={{cursor: "pointer"}}
                                                          className="badge badge-secondary text-bold">Details</span>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <div>
                                                            <span>Start Time : {formattedStart}</span>
                                                        </div>
                                                        <div>
                                                            <span>End Time : {formattedEnd}</span>
                                                        </div>
                                                    </Col>
                                                    <Col className="text-center" style={{marginTop: "-50px"}}>
                                                        <>
                                                            <div>
                                                            <span role="button"
                                                                  onClick={() => push(item.eventId, item.userId)}
                                                                  className="text-white text-underline">Admin Link</span>
                                                            </div>
                                                            {signedInUser.role === 'admin' && <>
                                                                <div>
                                                                    <a href={`${item?.gameLink}`}
                                                                       target="_blank" className="text-white">Game Link</a>
                                                                </div>
                                                                <div>
                                                                    <Link
                                                                        to={`/assessment/invitation/${item.eventId}`}
                                                                        className="text-white">Send Invites</Link>
                                                                </div>
                                                            </>}
                                                            {item.candidateFlow && <div>
                                                                <a href={`/candidate-flow/${item.eventId}`}
                                                                   target="_blank" className="text-white">Candidate flow
                                                                    Link</a>
                                                            </div>}
                                                        </>
                                                    </Col>
                                                    <Col className="text-right">
                                                        <Button className="footerButton text-white" color=""
                                                                onClick={() => deleteEvent(item.eventId)}>Delete</Button>
                                                    </Col>
                                                </Row>
                                            </div>)
                                    }
                                )}</>}
                        </Container>
                    </CardBody>
                </Card>
            </div>
        </Container>
        {/*Detials Modal*/}
        <div>
            <Modal size="lg" style={{maxWidth: '1200px', width: '100%'}} isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                    <h1 className="text-capitalize text-center">{event?.assessmentName} - Configurations</h1>
                </ModalHeader>
                <ModalBody>
                    {event?.hasOwnProperty('assessmentName') && <>
                        <Row>
                            <Col lg={3}>
                                <div className="listing-header pt-1">
                                    <img src={step1} height={55}/>
                                    <span
                                        className="text-white">{event.projectType === "progress" ? "Game" : "Assessment"} Information</span>
                                </div>
                                <div className="mt-3">
                                    <div>
                                        <label className="games-listing">{event?.assessmentName}</label>
                                    </div>
                                    <div>
                                        <label
                                            className="games-listing mt-2">{event?.assessmentFor}</label>
                                    </div>
                                    {event?.candidateFlow && <div>
                                        <label
                                            className="games-listing mt-2">Candidate Flow</label>
                                    </div>}
                                </div>
                            </Col>
                            <Col lg={3}>
                                <div className="listing-header pt-1">
                                    <img src={step2} height={55}/>
                                    <span
                                        className="text-white">Behavioral {event.projectType === "progress" ? "Competency" : "Assessment"}</span>
                                </div>
                                <div className="mt-3">
                                    {event?.selectedLevels.competencies.map((level, index) => (<div key={index}>
                                        <label className="games-listing mb-2">{level.name}</label>
                                    </div>))}
                                </div>
                            </Col>
                            {event.projectType === "progress" ?
                                <>
                                    <Col lg={3}>
                                        <div className="listing-header pt-1">
                                            <img src={step3} height={55}/>
                                            <span className="text-white">Mini Games</span>
                                        </div>
                                        <div className="mt-3">
                                            {event?.selectedLevels.games.map((level, index) => (<div key={index}>
                                                <label className="games-listing mb-2">{level.name}</label>
                                            </div>))}
                                        </div>
                                    </Col>
                                </> :
                                <>
                                    <Col lg={3}>
                                        <div className="listing-header pt-1">
                                            <img src={step3} height={55}/>
                                            <span className="text-white">Cognitive Games</span>
                                        </div>
                                        <div className="mt-3">
                                            {event?.selectedLevels.cognitive.map((level, index) => (<div key={index}>
                                                <label className="games-listing mb-2">{level.name}</label>
                                            </div>))}
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div className="listing-header pt-1">
                                            <img src={step4} height={55}/>
                                            <span className="text-white">Aptitude Games</span>
                                        </div>
                                        <div className="mt-3">
                                            {event?.selectedLevels.aptitude.map((level, index) => (<div key={index}>
                                                <label className="games-listing mb-2">{level.name}</label>
                                            </div>))}
                                        </div>
                                    </Col>
                                </>
                            }
                            {/*</Row>*/}
                            {/*<Row className="my-4">*/}
                            <Col lg={3}>
                                <div className="listing-header pt-1">
                                    <img src={event.projectType === "progress" ? step4 : step5} height={55}/>
                                    <span className="text-white">Registration Fields</span>
                                </div>
                                <div className="mt-3">
                                    {event?.registrationFields.map((field, index) => (<div key={index}>
                                        <label className="games-listing mb-2 text-capitalize">
                                            {field === "fullName" ? "Full Name" : field === "dateOfBirth" ? "Date of Birth" : field}
                                        </label>
                                    </div>))}
                                </div>
                            </Col>
                            <Col lg={3}>
                                <div className="listing-header pt-1">
                                    <img src={event.projectType === "progress" ? step5 : step6} height={55}/>
                                    <span className="text-white">Login Methods</span>
                                </div>
                                <div className="mt-3">
                                    {event?.loginMethod.map((method, index) => (<div key={index}>
                                        <label
                                            className="games-listing mb-2 text-capitalize">{method}</label>
                                    </div>))}
                                </div>
                            </Col>
                            <Col lg={3}>
                                <div className="listing-header pt-1">
                                    <img src={event.projectType === "progress" ? step6 : step7} height={55}/>
                                    <span className="text-white">Customize Artwork</span>
                                </div>
                                <div className="mt-3">
                                    {event?.companyLogo && <label className="games-listing mb-2 text-capitalize">
                                        {`${event?.assessmentName}-${event?.assessmentFor}-logo`}
                                    </label>}
                                </div>
                                <div className="mt-3">
                                    {event?.introVideo &&
                                        <label className="games-listing mb-2 text-capitalize">
                                            {event?.assessmentName}-${event?.assessmentFor}-Intro-Video
                                        </label>
                                    }
                                </div>
                            </Col>
                            <Col lg={3}>
                                <div className="listing-header pt-1">
                                    <img src={event.projectType === "progress" ? step7 : step8} height={55}/>
                                    <span className="text-white">Configure & Launch</span>
                                </div>
                                <div className="mt-3">
                                    <label className="list-item-heading">Start Time</label>
                                    <div>
                                        <label
                                            className="games-listing">{moment(new Date(event.startTime.seconds * 1000 + event.startTime.nanoseconds / 1000000)).format('YYYY-MM-DD HH:mm:ss')}</label>
                                    </div>
                                    <label className="list-item-heading">End Time</label>
                                    <div>
                                        <label
                                            className="games-listing mt-2">{moment(new Date(event.endTime.seconds * 1000 + event.endTime.nanoseconds / 1000000)).format('YYYY-MM-DD HH:mm:ss')}</label>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </>}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    </div>);
};
export default Dashboard;
